import FullPageLoader from '@components/FullPageLoader';
import useProjects from '@hooks/useProject';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { resetConfigs } from '@pages/ProjectBoard/slice';

import ChartBoard from './components/ChartBoard';
import { useGetProjectByIdQuery } from '@api/projects';
import AddChartNew from '@pages/AddChartNew';

interface Props {
  isGoAutoClicked?: boolean;
}

const ProjectBoard: FC<Props> = () => {
  const { projectId, collaborationId } = useParams();
  const [pollingInterval, setPollingInterval] = useState(0);
  const [isGoAutoClicked, setIsGoAutoClicked] = useState(false);
  const isBoardPreview = !!collaborationId;

  const dispatch = useDispatch();

  const { chartConfigs, getChartConfigs, isLoading, isProjectBoardEmpty } =
    useProjects({});

  const { data } = useGetProjectByIdQuery(
    { projectId, collaboration_id: collaborationId || '' },
    {
      pollingInterval: isGoAutoClicked ? pollingInterval : 0
    }
  );

  useEffect(() => {
    if (data?.auto_charts_executed && isGoAutoClicked) {
      setPollingInterval(0);
      getChartConfigs({
        projectId: projectId as string,
        collaboration_id: collaborationId as string
      });
    }
  }, [data]);

  useEffect(() => {
    if (data?.auto_charts_executed && chartConfigs && chartConfigs?.length)
      setIsGoAutoClicked(false);
  }, [data, chartConfigs]);

  useEffect(() => {
    if (isProjectBoardEmpty && isGoAutoClicked && data?.auto_charts_executed)
      setIsGoAutoClicked(false);
  }, [isProjectBoardEmpty, data?.auto_charts_executed]);

  useEffect(() => {
    if (isGoAutoClicked) setPollingInterval(500);
  }, [isGoAutoClicked]);

  useEffect(
    () => () => {
      dispatch(resetConfigs());
    },
    []
  );

  useEffect(() => {
    if (projectId && !isGoAutoClicked)
      getChartConfigs &&
        getChartConfigs({
          projectId: projectId,
          collaboration_id: collaborationId as string
        });
  }, [projectId]);

  if (isGoAutoClicked) {
    if (chartConfigs?.length && (data?.auto_charts_executed || isBoardPreview))
      return (
        <ChartBoard
          chartConfigs={chartConfigs}
          isBoardPreview={isBoardPreview}
        />
      );

    return <AddChartNew isLoading={true} isProjectMode />;
  }

  if (!chartConfigs || isLoading) return <FullPageLoader />;

  if (chartConfigs?.length || isBoardPreview)
    return (
      <ChartBoard chartConfigs={chartConfigs} isBoardPreview={isBoardPreview} />
    );

  return (
    <>
      <AddChartNew
        isGoAutoClicked={(value: boolean) => {
          if (value) setIsGoAutoClicked(value);
        }}
        isProjectMode
      />
    </>
  );
};

export default ProjectBoard;
